import React from 'react';
import { Link } from 'react-router-dom';
import Head from 'components/basics/head';
import MktAnnouncement from 'components/mkt/mkt-announcement';
import MktNav from 'components/navs/mkt-nav';
import MktHeader from 'components/mkt/mkt-header';
import MktConsumerPrefooter from 'components/mkt/mkt-consumer-prefooter';
import MktFooter from 'components/mkt/mkt-footer';
import FAWrapper from 'components/vendors/fa-wrapper';
import { MakeupHeader } from 'utils/assets/headers';
import { Container, Row, Col } from 'reactstrap';

const MktAboutRoute = (props) => {
  const { history } = props;

  // Render
  return (
    <div className='route'>
      <Head title='Blush - About' />
      <MktAnnouncement />
      <MktNav />
      <MktHeader
        size='md'
        title='About'
        bg={MakeupHeader}>
        <div className='mt-4'>
          <Link to='/book' className='btn btn-primary btn-lg'>Book Now<FAWrapper icon='chevron-right' className='sm ml-15' /></Link>
        </div>
      </MktHeader>


      <main className='mkt-main'>

        <section className='mkt-section'>
          <div className='mkt-section-body xs flex'>
            <Container>
              <Row>

                <Col md='3'>
                  <div className='mkt-section-title'>
                    <h2>Our Mission</h2>
                    <hr />
                  </div>
                </Col>

                <Col md={{ size: 8, offset: 1 }}>
                  <div className='mkt-section-content'>
                    <blockquote className='light italic'>
                      <span>"</span>
                      Making Beauty Convenient
                      <span>"</span>
                    </blockquote>
                  </div>
                </Col>

              </Row>
            </Container>
          </div>
        </section>

        <section className='mkt-section'>
          <div className='mkt-section-body xs flex'>
            <Container>
              <Row>

                <Col md='3'>
                  <div className='mkt-section-title'>
                    <h2>Our Story</h2>
                    <hr />
                  </div>
                </Col>

                <Col md={{ size: 8, offset: 1 }}>
                  <div className='mkt-section-content'>
                    <h6 className='p'>“Blush Now was born from a simple idea: beauty should be accessible, empowering, and fit into the lives of modern women not the other way around.
                      Whether you're a busy professional heading to a conference, an entrepreneur getting ready for a brand shoot, a bride on her big day, or a stay-at-home mom who finally booked a well-deserved night out we see you. We know how much you juggle, and we believe you deserve to feel confident and radiant, no matter the occasion.
                      Founded by women, powered by women, Blush Now exists to bring expert hair and makeup services right to your door making glam not just easy, but something you actually have time for. We’re on a mission to redefine beauty as something you do for you.”
                    </h6>
                  </div>
                </Col>

              </Row>
            </Container>
          </div>
        </section>

        <MktConsumerPrefooter />

      </main>
      <MktFooter />
    </div>
  );
}

export default MktAboutRoute;
